export interface Category {
  name: string;
  displayName: string;
  url: string;
  imageSeq: string;
  imagePrompt: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    displayName: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageSeq: "cat-shoes-01",
    imagePrompt: "Clean%20white%20minimalist%20sneakers%20on%20a%20light%20cream%20background%2C%20soft%20natural%20studio%20lighting%2C%20elegant%20product%20photography%20with%20gentle%20shadows%2C%20Scandinavian%20aesthetic%2C%20clean%20composition%2C%20high%20detail%20texture%20on%20the%20shoe%20material%2C%20no%20text%20or%20logos%2C%20neutral%20warm%20tones"
  },
  {
    name: "Hoodies",
    displayName: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    imageSeq: "cat-hoodies-02",
    imagePrompt: "Soft%20beige%20hoodie%20sweater%20folded%20neatly%20on%20a%20light%20wooden%20surface%2C%20warm%20natural%20daylight%20from%20a%20window%2C%20cozy%20minimalist%20product%20photography%2C%20soft%20fabric%20texture%20visible%2C%20cream%20and%20warm%20neutral%20color%20palette%2C%20Scandinavian%20style%2C%20clean%20simple%20composition%2C%20no%20visible%20branding"
  },
  {
    name: "TShirts",
    displayName: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    imageSeq: "cat-tshirts-03",
    imagePrompt: "Plain%20white%20cotton%20t-shirt%20hanging%20on%20a%20minimal%20wooden%20hanger%20against%20a%20soft%20cream%20wall%2C%20gentle%20natural%20lighting%2C%20clean%20Scandinavian%20product%20photography%2C%20subtle%20fabric%20texture%20details%2C%20warm%20neutral%20tones%2C%20simple%20elegant%20composition%2C%20no%20logos%20or%20text"
  },
  {
    name: "Jackets",
    displayName: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    imageSeq: "cat-jackets-04",
    imagePrompt: "Stylish%20light%20olive%20green%20bomber%20jacket%20laid%20flat%20on%20a%20cream%20linen%20background%2C%20soft%20diffused%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20visible%20fabric%20texture%20and%20stitching%20details%2C%20warm%20earthy%20tones%2C%20clean%20composition%2C%20Scandinavian%20aesthetic%2C%20no%20branding"
  },
  {
    name: "Pants",
    displayName: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    imageSeq: "cat-pants-05",
    imagePrompt: "Well-tailored%20beige%20linen%20trousers%20neatly%20folded%20on%20a%20light%20oak%20surface%2C%20soft%20natural%20daylight%2C%20minimalist%20product%20photography%20with%20clean%20lines%2C%20visible%20fabric%20weave%20texture%2C%20warm%20neutral%20cream%20tones%2C%20Scandinavian%20design%20aesthetic%2C%20simple%20elegant%20composition"
  },
  {
    name: "Headwear",
    displayName: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    imageSeq: "cat-headwear-06",
    imagePrompt: "Minimalist%20cream%20colored%20baseball%20cap%20placed%20on%20a%20light%20concrete%20surface%2C%20soft%20natural%20side%20lighting%2C%20clean%20product%20photography%2C%20subtle%20fabric%20texture%2C%20warm%20neutral%20aesthetic%2C%20Scandinavian%20minimalist%20style%2C%20simple%20composition%2C%20no%20visible%20branding%20or%20logos"
  },
  {
    name: "Sets",
    displayName: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    imageSeq: "cat-sets-07",
    imagePrompt: "Coordinated%20matching%20set%20of%20cream%20loungewear%20top%20and%20bottom%20neatly%20arranged%20on%20a%20light%20wooden%20floor%2C%20soft%20diffused%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20visible%20soft%20fabric%20texture%2C%20warm%20neutral%20tones%2C%20Scandinavian%20aesthetic%2C%20clean%20composition"
  },
  {
    name: "Underwear",
    displayName: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    imageSeq: "cat-underwear-08",
    imagePrompt: "Soft%20cotton%20underwear%20basics%20neatly%20folded%20on%20a%20cream%20linen%20fabric%20background%2C%20gentle%20studio%20lighting%2C%20clean%20minimalist%20product%20photography%2C%20subtle%20texture%20details%2C%20warm%20neutral%20color%20palette%2C%20Scandinavian%20aesthetic%2C%20simple%20elegant%20composition%2C%20no%20branding"
  },
  {
    name: "Jersey",
    displayName: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    imageSeq: "cat-jersey-09",
    imagePrompt: "Premium%20sports%20jersey%20in%20soft%20sage%20green%20color%20draped%20over%20a%20minimal%20wooden%20hanger%2C%20clean%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20visible%20breathable%20fabric%20texture%2C%20warm%20earthy%20tones%2C%20Scandinavian%20design%20aesthetic%2C%20simple%20composition%2C%20no%20logos"
  },
  {
    name: "Accessories",
    displayName: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    imageSeq: "cat-accessories-10",
    imagePrompt: "Minimalist%20leather%20watch%20and%20bracelet%20set%20arranged%20on%20a%20light%20cream%20marble%20surface%2C%20soft%20natural%20lighting%2C%20elegant%20product%20photography%2C%20visible%20leather%20grain%20texture%2C%20warm%20neutral%20tones%2C%20Scandinavian%20luxury%20aesthetic%2C%20clean%20composition%2C%20no%20branding"
  },
  {
    name: "Bags",
    displayName: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    imageSeq: "cat-bags-11",
    imagePrompt: "Stylish%20tan%20leather%20tote%20bag%20placed%20on%20a%20light%20oak%20table%2C%20soft%20natural%20window%20light%2C%20minimalist%20product%20photography%20with%20clean%20background%2C%20visible%20leather%20texture%20and%20stitching%2C%20warm%20earthy%20tones%2C%20Scandinavian%20aesthetic%2C%20simple%20elegant%20composition%2C%20no%20logos"
  },
  {
    name: "Belts",
    displayName: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    imageSeq: "cat-belts-12",
    imagePrompt: "Premium%20braided%20leather%20belt%20coiled%20elegantly%20on%20a%20cream%20linen%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20visible%20leather%20grain%20and%20buckle%20details%2C%20warm%20neutral%20tones%2C%20Scandinavian%20aesthetic%2C%20clean%20simple%20composition%2C%20no%20branding"
  },
  {
    name: "Perfumes",
    displayName: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    imageSeq: "cat-perfumes-13",
    imagePrompt: "Elegant%20minimalist%20glass%20perfume%20bottle%20on%20a%20light%20cream%20surface%20with%20soft%20shadows%2C%20gentle%20studio%20lighting%2C%20luxury%20product%20photography%2C%20visible%20glass%20reflections%20and%20texture%2C%20warm%20neutral%20tones%2C%20Scandinavian%20aesthetic%2C%20clean%20composition%2C%20no%20text%20or%20logos"
  },
  {
    name: "OtherStuff",
    displayName: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    imageSeq: "cat-other-14",
    imagePrompt: "Assorted%20lifestyle%20accessories%20including%20sunglasses%20and%20a%20small%20wallet%20neatly%20arranged%20on%20a%20light%20cream%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20tones%2C%20Scandinavian%20aesthetic%2C%20clean%20composition%2C%20no%20branding"
  },
];